import React from 'react';
// import HouseIcon from '../../assets/svg/HouseIcon';
// import MessageIcon from '../../assets/svg/MessageIcon';

function DeliveryCard(props) {
    return (
        <div>

            <div className="profile-info-wrapper top-pad">
                <div className="delivery-info-wrapper wider-pad">
                    <div className="name-title">
                        {/* House icon */}
                        <div className="text-block-8 inline">Delivery Address:</div>
                    </div>
                    <div className="name-info smaller">
                    {props.deliveryAddress || 'No Address.'} 
                    </div>
                </div>

                {props.deliveryInstructions && (
                    <div className="delivery-info-wrapper wider-pad">
                        <div className="name-title">
                            {/* Chat icon */}
                            <div className="text-block-8">
                                Special Instructions:
                            </div>
                        </div>
                        <div className="name-info special smaller">
                            { props.deliveryInstructions || ' '  }
                        </div>  
                       
                    </div>
                )}

            </div>

          

          
         </div>
    );
}

export default DeliveryCard;